import { render, staticRenderFns } from "./AscAlertIconCount.vue?vue&type=template&id=6bc3f106&scoped=true&"
import script from "./AscAlertIconCount.vue?vue&type=script&lang=js&"
export * from "./AscAlertIconCount.vue?vue&type=script&lang=js&"
import style0 from "./AscAlertIconCount.vue?vue&type=style&index=0&id=6bc3f106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3f106",
  null
  
)

export default component.exports